import { UserOrg } from "Interfaces/User/UserData";
import useAuth from 'Modules/firebase/use-auth';
import { ROUTES } from 'app/routes/constants';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { useGetUserOrgsLazyQuery } from 'generated/graphql';
import { UserOrg as GraphQLUserOrg } from 'graphql/types/userOrgs';
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { userActions } from "store/user/userSlice";

export function useUserOrgs(validateAuth = true) {
    const { user, loading, isAuthenticated, ...auth } = useAuth();
    const [userOrganizations, setUserOrganizations] = useState<UserOrg[]>();
    const navigate = useOrgNavigate();
    const dispatch = useDispatch();

    const [getUserOrgs, { loading: fetchingUserOrgs }] =
        useGetUserOrgsLazyQuery();

    // Handle login redirect
    useEffect(() => {
        if (validateAuth && !loading && !isAuthenticated) {
            navigate(ROUTES.AUTH_LOGIN);
        }
    }, [isAuthenticated, loading, validateAuth]);

    // Fetch user organizations only when authenticated
    useEffect(() => {
        const queryUserOrgs = async () => {
            const { data } = await getUserOrgs({
                variables: {
                    uid: user?.uid || '',
                },
            });

            const gqlOrgs = data?.userOrganizations || [];
            const mappedOrgs: UserOrg[] = gqlOrgs.map((org: GraphQLUserOrg) => ({
                orgId: org.instanceId ?? '',
                slug: org.tenantUrl ?? '',
                displayName: org.displayName ?? '',
                name: org.name ?? '',
            }));

            setUserOrganizations(mappedOrgs);
            dispatch(userActions.SET_USER_ORGANIZATIONS(mappedOrgs));
        };

        if (isAuthenticated && !fetchingUserOrgs && user?.uid) {
            queryUserOrgs();
        }
    }, [isAuthenticated, fetchingUserOrgs, getUserOrgs, user?.uid]);

    return {
        user,
        loading: loading || fetchingUserOrgs,
        auth: auth,
        userOrganizations,
    };
}
